import { ICommunityUser, IMainPhoto } from '../interfaces/IUser';
import Photo from './photo';

export default class User {
  userId: number | null;
  userName: string;
  memberType: string | null;
  memberTypeTitle: { [key: string]: string };
  age1: number | null;
  age2: number | null;
  ageTitle: string;
  location: string;
  matchingInterests: number | null;
  mainPhoto: IMainPhoto;
  isOnline: boolean;
  memberLevel: number | null;
  isDiamond: boolean;
  countryId: number | null;
  storyCount: number;
  isViewable: boolean;

  constructor() {
    this.userId = null;
    this.userName = '';
    this.memberType = null;
    this.memberTypeTitle = {};
    this.age1 = null;
    this.age2 = null;
    this.ageTitle = '';
    this.location = '';
    this.matchingInterests = null;
    this.mainPhoto = {};
    this.isOnline = false;
    this.memberLevel = null;
    this.isDiamond = false;
    this.countryId = null;
    this.storyCount = 0;
    this.isViewable = true;
  }

  static mappingMemberTypeTitle(object: any): { [key: string]: string } {
    const newObject: { [key: string]: string } = {};
    newObject.abbr = object ? object.Abbr : '';
    newObject.singular = object ? object.Singular : '';
    newObject.plural = object ? object.Plural : '';
    return newObject;
  }

  static mappingPhoto(_obj: any): { [key: string]: any } {
    const obj: { [key: string]: any } = {
      photoId: null,
      height: 0,
      width: 0,
      isUserImage: false,
      isPublic: false,
      classification: null,
      thumbUrl: '',
      fullUrl: '',
    };
    obj.photoId = _obj.PhotoID;
    obj.height = _obj.Height ? _obj.Height : 0;
    obj.width = _obj.Width ? _obj.Width : 0;
    obj.isUserImage = _obj.IsUserImage ? _obj.IsUserImage : false;
    obj.isPublic = _obj.IsPublic ? _obj.IsPublic : false;
    obj.classification = _obj.Classification;
    obj.thumbUrl = _obj.ThumbUrl ? _obj.ThumbUrl : '';
    obj.fullUrl = _obj.FullUrl ? _obj.FullUrl : '';
    return obj;
  }

  static mappingUser(_obj: any): ICommunityUser {
    const obj = new User();
    obj.userId = _obj.MemberID ? _obj.MemberID : null;
    obj.userName = _obj.UserName ? _obj.UserName : '';
    obj.memberType = _obj.MemberType ? _obj.MemberType : null;
    obj.memberTypeTitle = _obj.MemberTypeTitle ? User.mappingMemberTypeTitle(_obj.MemberTypeTitle) : {};
    obj.age1 = _obj.Age1 ? _obj.Age1 : null;
    obj.age2 = _obj.Age2 ? _obj.Age2 : null;
    obj.ageTitle = _obj.AgeTitle ? _obj.AgeTitle : '';
    obj.location = _obj.Location ? _obj.Location : '';
    obj.matchingInterests = _obj.MatchingInterests ? _obj.MatchingInterests : 0;
    obj.mainPhoto = _obj.MainPhoto ? Photo.mappingObject(_obj.MainPhoto) : {};
    obj.isOnline = _obj.IsOnline ? _obj.IsOnline : false;
    obj.memberLevel = _obj.MemberLevel ? _obj.MemberLevel : 0;
    obj.isDiamond = _obj.IsDiamond ? _obj.IsDiamond : false;
    obj.countryId = _obj.CountryID ? _obj.CountryID : null;
    obj.isViewable = _obj.hasOwnProperty('IsViewable') ? _obj.IsViewable : true;
    obj.storyCount = _obj.StoryCount || 0;
    return obj;
  }

  static mappingUsers(_data: any[]): ICommunityUser[] {
    return _data.map(item => this.mappingUser(item));
  }
}
